import { Helmet } from 'react-helmet-async';
import React from 'react';
import UserFormContainer from '../../../containers/organizations/UserFormContainer.jsx';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

const EditUser = ({ userId, slug }) => (
  <>
    <Helmet>
      <title>Edit User | ChangeSync</title>
    </Helmet>

    <UserFormContainer userId={userId} slug={slug} />
  </>
);

EditUser.getInitialProps = ({ query }) => ({
  slug: query.slug,
  userId: Number(query.userId),
});

export default requireAuth(withRouterParams(EditUser));
